import React from "react";

const SIZE = 120;
const STROKE = 11;
const RADIUS = (SIZE - STROKE) / 2;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

// Shared by the dashboard area tiles and the area details box so both show
// the same visualization. Ring turns amber near full and red when full/over.
function UsageRing({ value, total, label }) {
  const percent = total > 0 ? Math.min(value / total, 1) : 0;
  const color =
    total > 0 && value >= total ? "var(--bs-danger)"
    : percent >= 0.9 ? "var(--bs-warning)"
    : "var(--ez-orange)";

  return (
    <div className="d-flex flex-column align-items-center text-center">
      <div style={{ position: "relative", width: "100%", maxWidth: SIZE }}>
        <svg viewBox={`0 0 ${SIZE} ${SIZE}`} width="100%" style={{ display: "block", transform: "rotate(-90deg)" }}>
          <circle
            cx={SIZE / 2} cy={SIZE / 2} r={RADIUS}
            fill="none" stroke="var(--bs-secondary-bg)" strokeWidth={STROKE}
          />
          <circle
            cx={SIZE / 2} cy={SIZE / 2} r={RADIUS}
            fill="none" stroke={color} strokeWidth={STROKE} strokeLinecap="round"
            strokeDasharray={CIRCUMFERENCE}
            strokeDashoffset={CIRCUMFERENCE * (1 - percent)}
            style={{ transition: "stroke-dashoffset .4s ease" }}
          />
        </svg>
        <div
          className="d-flex flex-column align-items-center justify-content-center"
          style={{ position: "absolute", inset: 0, lineHeight: 1.1 }}
        >
          <span className="fw-bold" style={{ fontSize: "1.5rem" }}>{value}</span>
          <span className="text-muted" style={{ fontSize: "0.75rem" }}>/ {total}</span>
        </div>
      </div>
      <div className="text-muted small mt-2">{label}</div>
    </div>
  );
}

export default UsageRing;
